import * as React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import {
  Divider,
  FormControl,
  FormControlLabel,
  FormHelperText,
  Grid,
  InputAdornment,
  Radio,
  RadioGroup,
  Skeleton,
  Stack,
  TextField,
} from "@mui/material";
import styled from "@emotion/styled";
import Asynchronous from "./AutoComplete";
import { OutlinedInput } from "@mui/material";
import { SwitchButton } from "../Button/SwitchButton";
import { StyledDivider } from "../Divider/StyledDivider";
import LgaAsynchronous from "./lgaAutocomplete";

const sourceOfFundsArr = ['Loan', 'Grant', 'Personal']

export default function ViewandEditForm({
  isFoundCM,
  handleIsFoundCM,
  handleResetFoundCM,
  handleCloseDialog,
  formType,
  singleBusinessData,
  handleBusinessUpdate,
  formValues,
  updateValue,
  updateLgaValue,
  stateHandler,
  lgaHandler,
  lgaValues,
  values,
  formStates,
  handleBlurEmail,
  showSkeleton,
  handleBlurPhoneNumber,
  // checked,
}) {
  // const [checked, setChecked] = React.useState(false);

  const handleClose = () => {
    handleCloseDialog();
    // handleReset()
  };

  return (
    <Box sx={{ width: "100%" }}>
      <React.Fragment>
        <Box p="5px 10px">
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <FormControl fullWidth variant="outlined">
                <label
                  style={{
                    marginBottom: "10px",
                    fontFamily: Typography.secondaryFont,
                  }}
                  htmlFor="businessname"
                >
                  <Typography sx={{ fontSize: "14px" }}>
                    Business Name
                  </Typography>
                </label>
                {showSkeleton ? (
                  <Skeleton
                    variant="rounded"
                    animation="wave"
                    height={40}
                    width={500}
                  />
                ) : (
                  <TextField
                    // value={generalFunc.firstLetterUppercase(formValues.name)}
                    error={formStates.businessNameError}
                    helperText={formStates.businessNameErrorMsg}
                    name="businessName"
                    value={formValues.businessName}
                    size="small"
                    id="businessname"
                    variant="outlined"
                    InputProps={{
                      spellCheck: true,
                      lang: "English",
                      readOnly: formType === "view" ? true : false,
                    }}
                    onChange={handleBusinessUpdate}
                  />
                )}
              </FormControl>
            </Grid>
            <Grid item xs={12}>
              <FormControl fullWidth variant="outlined">
                <label
                  style={{
                    marginBottom: "10px",
                    fontFamily: Typography.secondaryFont,
                  }}
                  htmlFor="email"
                >
                  <Typography sx={{ fontSize: "14px" }}>
                    Email Address
                  </Typography>
                </label>
                {showSkeleton ? (
                  <Skeleton
                    variant="rounded"
                    animation="wave"
                    height={40}
                    width={500}
                  />
                ) : (
                  <OutlinedInput
                    name="email"
                    id="outlined-adornment-email"
                    size="small"
                    value={formValues.email}
                    endAdornment={
                      <InputAdornment position="end">@</InputAdornment>
                    }
                    onChange={handleBusinessUpdate}
                    onBlur={handleBlurEmail}
                    aria-describedby="outlined-email-helper-text"
                    inputProps={{
                      "aria-label": "email",
                      readOnly: formType === "view" ? true : false,
                    }}
                    error={formStates.emailAddressError}
                  />
                )}
              </FormControl>
              <FormHelperText error id="accountId-error">
                {formStates.emailAddressErrorMsg}
              </FormHelperText>
            </Grid>
            <Grid item xs={6}>
              <FormControl fullWidth variant="outlined">
                <label
                  style={{
                    marginBottom: "10px",
                    fontFamily: Typography.secondaryFont,
                  }}
                  htmlFor="phonenumber"
                >
                  <Typography sx={{ fontSize: "14px" }}>
                    Phone Number
                  </Typography>
                </label>
                {showSkeleton ? (
                  <Skeleton
                    variant="rounded"
                    animation="wave"
                    height={40}
                    width={200}
                  />
                ) : (
                  <TextField
                    name="phoneNumber"
                    /*  error={error}
                    helperText={helperText}
                    value={generalFunc.firstLetterUppercase(formValues.name)} */
                    type="number"
                    value={formValues.phoneNumber}
                    onChange={handleBusinessUpdate}
                    size="small"
                    id="phonenumber"
                    variant="outlined"
                    InputProps={{
                      spellCheck: true,
                      lang: "English",
                      readOnly: formType === "view" ? true : false,
                      startAdornment: (
                        <InputAdornment position="start">+234</InputAdornment>
                      ),
                    }}
                    error={formStates.phoneNumberError}
                    helperText={formStates.phoneNumberErrorMsg}
                    onBlur={handleBlurPhoneNumber}
                  />
                )}
              </FormControl>
            </Grid>
            <Grid item xs={6}>
              <FormControl fullWidth variant="outlined">
                <label
                  style={{
                    marginBottom: "10px",
                    fontFamily: Typography.secondaryFont,
                  }}
                  htmlFor="totalnumofyouths"
                >
                  <Typography sx={{ fontSize: "14px" }}>
                    Total Number of Youths Trained
                  </Typography>
                </label>
                {showSkeleton ? (
                  <Skeleton
                    variant="rounded"
                    animation="wave"
                    height={40}
                    width={500}
                  />
                ) : (
                  <TextField
                    type="number"
                    value={formValues.staffStrength}
                    onChange={handleBusinessUpdate}
                    name="staffStrength"
                    size="small"
                    id="totalnumofyouths"
                    variant="outlined"
                    InputProps={{
                      spellCheck: true,
                      lang: "English",
                      readOnly: formType === "view" ? true : false,
                    }}
                    error={formStates.staffStrengthError}
                    helperText={formStates.staffStrengthErrorMsg}
                  />
                )}
              </FormControl>
            </Grid>
            <Grid item xs={6}>
              <FormControl fullWidth variant="outlined">
                <label
                  style={{
                    marginBottom: "10px",
                    fontFamily: Typography.secondaryFont,
                  }}
                  htmlFor="sourceoffunds"
                >
                  <Typography sx={{ fontSize: "14px" }}>
                    Source of Funds
                  </Typography>
                </label>
                {formType === "view" ? (
                  showSkeleton ? (
                    <Skeleton
                      variant="rounded"
                      animation="wave"
                      height={40}
                      width={200}
                    />
                  ) : (
                    <TextField
                      value={sourceOfFundsArr[formValues.sourceOfFund]}
                      name="sourceOfFund"
                      onChange={handleBusinessUpdate}
                      size="small"
                      id="sourceoffunds"
                      variant="outlined"
                      InputProps={{
                        spellCheck: true,
                        lang: "English",
                        readOnly: formType === "view" ? true : false,
                      }}
                    />
                  )
                ) : showSkeleton ? (
                  <Skeleton
                    variant="rounded"
                    animation="wave"
                    height={40}
                    width={200}
                  />
                ) : (
                  <RadioGroup
                    row
                    aria-labelledby="demo-row-radio-buttons-group-label"
                    name="sourceOfFund"
                    value={formValues.sourceOfFund}
                    // value={formValues.sourceOfFund ==="Loan"?0:1}
                    onChange={(e) => {
                      handleBusinessUpdate(e);
                    }}
                  >
                    <FormControlLabel
                      value={0}
                      control={<Radio />}
                      label="Loan"
                    />
                    <FormControlLabel
                      value={1}
                      control={<Radio />}
                      label="Grant"
                    />
                    <FormControlLabel
                      value={2}
                      control={<Radio />}
                      label="Personal"
                    />
                  </RadioGroup>
                )}
              </FormControl>
            </Grid>
            <Grid item xs={6}>
              <FormControl fullWidth variant="outlined">
                <label
                  style={{
                    marginBottom: "10px",
                    fontFamily: Typography.secondaryFont,
                  }}
                  htmlFor="businessStatus"
                >
                  <Typography sx={{ fontSize: "14px" }}>
                    Current Status of Business
                  </Typography>
                </label>
                <Stack direction="row" spacing={1} alignItems="center">
                  {showSkeleton ? (
                    <Skeleton
                      variant="rounded"
                      animation="wave"
                      height={40}
                      width={500}
                    />
                  ) : (
                    <SwitchButton
                      // defaultChecked
                      name="isActive"
                      disabled={formType === "view" ? true : false}
                      inputProps={{ "aria-label": "ant design" }}
                      checked={formValues?.isActive || false}
                      onChange={handleBusinessUpdate}
                    />
                  )}

                  <Typography
                    style={{
                      color: formValues.isActive ? "#016c34" : "#bfbfbf",
                    }}
                  >
                    {showSkeleton ? (
                      <Skeleton />
                    ) : formValues.isActive ? (
                      "Active"
                    ) : (
                      "Inactive"
                    )}
                  </Typography>
                </Stack>
              </FormControl>
            </Grid>
            <Grid item xs={12}>
              <Box mb={1} mt={2}>
                <StyledDivider textAlign="left">
                  <Typography variant="subtitle2" sx={{ color: "#949494" }}>
                    Business Address
                  </Typography>
                </StyledDivider>
              </Box>
            </Grid>
            <Grid item xs={12}>
              <FormControl fullWidth variant="outlined">
                <label
                  style={{
                    marginBottom: "10px",
                    fontFamily: Typography.secondaryFont,
                  }}
                  htmlFor="streetaddress"
                >
                  <Typography sx={{ fontSize: "14px" }}>
                    Street Address
                  </Typography>
                </label>
                {showSkeleton ? (
                  <Skeleton
                    variant="rounded"
                    animation="wave"
                    height={40}
                    width={500}
                  />
                ) : (
                  <TextField
                    name="streetAddress"
                    /*  error={error}
                    helperText={helperText}
                    value={generalFunc.firstLetterUppercase(formValues.name)} */
                    value={formValues.streetAddress}
                    onChange={handleBusinessUpdate}
                    size="small"
                    id="streetaddress"
                    variant="outlined"
                    InputProps={{
                      spellCheck: true,
                      lang: "English",
                      readOnly: formType === "view" ? true : false,
                    }}
                    error={formStates.streetAddressError}
                    helperText={formStates.streetAddressErrorMsg}
                  />
                )}
              </FormControl>
            </Grid>
            <Grid item xs={6}>
              <FormControl fullWidth variant="outlined">
                <label
                  style={{
                    marginBottom: "10px",
                    fontFamily: Typography.secondaryFont,
                  }}
                  htmlFor="state"
                >
                  <Typography sx={{ fontSize: "14px" }}>
                    {" "}
                    State of Location
                  </Typography>
                </label>
                {showSkeleton ? (
                  <Skeleton
                    variant="rounded"
                    animation="wave"
                    height={40}
                    width={500}
                  />
                ) : (
                  <Asynchronous
                    values={values}
                    disabled={formType === "view" ? true : false}
                    stateData={formValues.state}
                    updateValue={updateValue}
                    stateHandler={stateHandler}
                    formStates={formStates}
                  />
                )}
                {/* <TextField
                      size="small"
                      id="businessname"
                      variant="outlined"
                     InputProps={{
                        spellCheck: true,
                        lang: "English",
                        readOnly:formType==="view"?true:false,
                      }}
                    /> */}
              </FormControl>
            </Grid>
            <Grid item xs={6}>
              <FormControl fullWidth variant="outlined">
                <label
                  style={{
                    marginBottom: "10px",
                    fontFamily: Typography.secondaryFont,
                  }}
                  htmlFor="lga"
                >
                  <Typography sx={{ fontSize: "14px" }}>
                    {" "}
                    LGA of Location
                  </Typography>
                </label>
                <LgaAsynchronous
                  values={values}
                  lgaValues={lgaValues}
                  disabled={formType === "view" ? true : false}
                  stateData={formValues.state}
                  updateLgaValue={updateLgaValue}
                  lgaHandler={lgaHandler}
                  formStates={formStates}
                />
              </FormControl>
            </Grid>
          </Grid>
        </Box>
      </React.Fragment>
    </Box>
  );
}
